import * as React from 'react';
import classnames from 'classnames';
import { HtmlHeadInclude } from '@msdyn365-commerce/core';

export interface IDescriptionProps {
    description: string;
    resources: {
        descriptionShowMoreText: string;
        descriptionShowLessText: string;
    };
}

const InitialStateScript = `
    (function() {
        console.log('Checking if description is long enough to show expand/collapse button');
        const desc = document.getElementById('expand-collapse-description');
        const button = document.getElementById('expand-collapse-description-button');
        const fade = document.getElementById('expand-collapse-description-fade');
        if (desc && button) {
            console.log('Description offsetHeight:', desc.offsetHeight);
            console.log('Description scrollHeight:', desc.scrollHeight);
            if (desc.offsetHeight < desc.scrollHeight) {
                button.style.visibility = 'visible';
                if (fade) {
                    fade.style.display = 'block';
                }
                console.log('Description is long, showing expand/collapse button');
            } else {
                button.style.visibility = 'hidden';
                if (fade) {
                    fade.style.display = 'none';
                }
                console.log('Description is short, hiding expand/collapse button');
            }
        }
    })();
`;

const Description = (props: IDescriptionProps) => {
    const [descriptionExpanded, setDescriptionExpanded] = React.useState(false);

    React.useEffect(() => {
        // Setup Observer to watch for changes in description width/height causing it to wrap lines again
        const desc = document.getElementById('expand-collapse-description');
        const button = document.getElementById('expand-collapse-description-button');
        const fade = document.getElementById('expand-collapse-description-fade');

        if (!desc || !button) {
            console.warn('Description or button element not found for expand/collapse functionality');
            return;
        }

        const observer = new ResizeObserver(() => {
            console.log('Description resized, checking if expand/collapse button should be shown');
            console.log('Description offsetHeight:', desc.offsetHeight);
            console.log('Description scrollHeight:', desc.scrollHeight);
            const lineHeight = parseInt(window.getComputedStyle(desc).lineHeight, 10);
            const maxHeight = !isNaN(lineHeight) ? lineHeight * 4 : undefined;
            console.log('Description maxHeight for 4 lines:', maxHeight);

            // If expanded, we hide/show the expand button if description can fit within the max height (don't auto toggle)
            if (maxHeight && descriptionExpanded) {
                if (desc.scrollHeight <= maxHeight) {
                    button.style.visibility = 'hidden';
                    if (fade) {
                        fade.style.display = 'none';
                    }
                    console.log('Description is expanded but can fit within max height, hiding expand/collapse button');
                } else {
                    button.style.visibility = 'visible';
                    console.log('Description is expanded and cannot fit within max height, showing expand/collapse button');
                }
            } else if (desc.offsetHeight < desc.scrollHeight) {
                button.style.visibility = 'visible';
                if (fade) {
                    fade.style.display = 'block';
                }
                console.log('Description is long, showing expand/collapse button');
            } else {
                button.style.visibility = 'hidden';
                if (fade) {
                    fade.style.display = 'none';
                }
                console.log('Description is short, hiding expand/collapse button');
            }
        });

        observer.observe(desc);
        return () => {
            observer.disconnect();
        };
    }, [descriptionExpanded]);

    return (
        <div className='ms-buybox__product-description-container'>
            <HtmlHeadInclude>
                <script type='text/javascript' dangerouslySetInnerHTML={{ __html: InitialStateScript }} />
            </HtmlHeadInclude>
            <div className='ms-buybox__product-description-wrapper'>
                <p id='expand-collapse-description' className={classnames(`ms-buybox__product-description`, { expanded: descriptionExpanded })}>
                    {props.description}
                </p>
                <div
                    className='fade-overlay'
                    id='expand-collapse-description-fade'
                    style={{ display: 'none', opacity: descriptionExpanded ? 0 : 1 }}
                />
            </div>
            <button
                className={classnames('ms-buybox__product-description-wrapper__button', { expanded: descriptionExpanded })}
                id='expand-collapse-description-button'
                onClick={() => setDescriptionExpanded(!descriptionExpanded)}
                style={{ visibility: 'hidden' }}
            >
                {descriptionExpanded ? props.resources.descriptionShowLessText : props.resources.descriptionShowMoreText}
            </button>
        </div>
    );
};

export default Description;